<template>
    <el-button  :type="type" v-bind="$attrs" v-on="$listeners" :icon="icon">
      <slot v-if="$slots.default"></slot>
      <span v-else>添加</span>
    </el-button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'primary'
        },
      icon: {
          type: String,
          default: 'el-icon-plus'
      }
    },
    methods: {
    }
}
</script>
